import { render, staticRenderFns } from "./CheckAll.vue?vue&type=template&id=22f61240"
import script from "./CheckAll.vue?vue&type=script&lang=js"
export * from "./CheckAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports